import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { CheckCircle2, Phone } from 'lucide-react';
export function TubToShowerConversionPage() {
  return <div className="flex flex-col min-h-screen pt-24 pb-20" data-id="element-539">
      {/* Hero */}
      <section className="relative bg-gray-50 py-16 md:py-24 overflow-hidden" data-id="element-540">
        <div className="absolute inset-0 z-0" data-id="element-541">
          <img src="https://cdn.magicpatterns.com/uploads/umu2CyKZR5r5C6pgqyhmGV/tub-to-shower-conversion.jpg" alt="Tub to shower conversion" className="w-full h-full object-cover object-center" data-id="element-542" />
          <div className="absolute inset-0 bg-white/85" data-id="element-543"></div>
        </div>

        <div className="container relative z-10 mx-auto px-4 md:px-6" data-id="element-544">
          <div className="max-w-3xl mx-auto text-center" data-id="element-545">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-546">
              Tub-to-Shower Conversions in Northern Indiana
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-8" data-id="element-547">
              Replace your old bathtub with a modern, accessible walk-in shower
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-548">
              <Link to="/contact" data-id="element-549">
                <Button size="lg" data-id="element-550">Get Free Consultation</Button>
              </Link>
              <Button variant="outline" size="lg" data-id="element-551">
                <Phone className="mr-2 h-5 w-5" data-id="element-552" />
                (574) 914-1522
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16" data-id="element-553">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-554">
          <div className="prose prose-lg max-w-none" data-id="element-555">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-556">
              Modern Shower Solutions for Your Lifestyle
            </h2>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-557">
              If you rarely use your bathtub or find it difficult to step over
              the high tub wall, a tub-to-shower conversion might be the perfect
              solution. Lucky Duck Bathroom Company specializes in transforming
              outdated bathtubs into beautiful, functional walk-in showers
              throughout Northern Indiana. Our conversions combine safety,
              accessibility, and modern design to create a bathroom that works
              better for your daily routine.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-558">
              Benefits of Converting Your Tub to a Shower
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-559">
              Tub-to-shower conversions offer numerous advantages for
              homeowners. Walk-in showers provide easier access, reducing the
              risk of slips and falls—especially important for older adults or
              anyone with mobility concerns. They're also easier to clean and
              maintain than traditional tubs, saving you time and effort on
              bathroom upkeep.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-560">
              Modern shower designs can actually make your bathroom feel more
              spacious and contemporary. With options like frameless glass
              doors, built-in seating, multiple showerheads, and custom tile
              work, your new shower becomes a stylish focal point that enhances
              your home's value and appeal.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-561">
              Our Tub-to-Shower Conversion Process
            </h3>

            <div className="bg-gray-50 p-6 rounded-lg mb-6" data-id="element-562">
              <ul className="space-y-3" data-id="element-563">
                {['Free in-home consultation and measurements', 'Design options tailored to your space and budget', 'Professional removal of existing tub and surround', 'Plumbing modifications as needed', 'Installation of new shower base and walls', 'Custom tile work or acrylic wall systems', 'Glass door or curtain installation', 'New fixtures, hardware, and accessories'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-564">
                    <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-0.5" data-id="element-565" />
                    <span className="text-gray-700" data-id="element-566">{item}</span>
                  </li>)}
              </ul>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-567">
              Design Options for Your New Shower
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-568">
              We offer a wide range of design possibilities to match your style
              and functional needs. Choose from ceramic or porcelain tile in
              countless colors and patterns, or opt for low-maintenance acrylic
              wall systems that resist mold and mildew. Add luxury features like
              rainfall showerheads, handheld sprayers, built-in niches for
              storage, fold-down seating, and grab bars that blend seamlessly
              with your design.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-569">
              Our team works with you to select materials and features that fit
              your budget while delivering the quality and durability you
              expect. We source products from trusted manufacturers and back our
              installations with solid warranties for your peace of mind.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-570">
              Accessibility and Safety Features
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-571">
              Safety is a top priority in our tub-to-shower conversions. We can
              incorporate low-threshold or zero-threshold entries for wheelchair
              accessibility, install strategically placed grab bars, add
              non-slip flooring, and include built-in seating for comfort and
              stability. These features don't compromise style—modern
              accessibility options blend beautifully with contemporary bathroom
              designs.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-572">
              Why Choose Lucky Duck for Your Conversion?
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-573">
              As a family-owned business serving Northern Indiana, we understand
              the importance of creating bathrooms that work for real life. Our
              experienced team handles every aspect of your conversion with
              skill and care, from proper waterproofing and plumbing to precise
              tile installation and finishing details. We keep your home clean
              and protected throughout the project and complete most conversions
              in just a few days, minimizing disruption to your routine.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-574">
              We serve South Bend, Mishawaka, Elkhart, Goshen, Granger, and
              surrounding Northern Indiana communities with honest pricing,
              quality workmanship, and the personalized service you deserve. Our
              reputation is built on customer satisfaction, and we're committed
              to exceeding your expectations on every project.
            </p>

            <div className="bg-[#8BA888]/10 border-l-4 border-[#8BA888] p-6 rounded-r-lg mt-8" data-id="element-575">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-576">
                Ready to Replace Your Tub with a Beautiful Shower?
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-577">
                Contact Lucky Duck Bathroom Company today for a free
                consultation and discover how a tub-to-shower conversion can
                transform your bathroom.
              </p>
              <Link to="/contact" data-id="element-578">
                <Button size="lg" data-id="element-579">Schedule Free Consultation</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}